class BrandsDescriptionsSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentIndex = 0;
    this.items = document.querySelectorAll(".brands-descriptions__item");

    this.showItem(this.currentIndex);

    document
      .querySelector(".brands-descriptions__right-button")
      .addEventListener("click", () => this.nextItem());
    document
      .querySelector(".brands-descriptions__left-button")
      .addEventListener("click", () => this.prevItem());
  }

  showItem(index) {
    this.items.forEach((item, i) => {
      item.classList.toggle("active", i === index);
    });
  }

  nextItem() {
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    this.showItem(this.currentIndex);
  }

  prevItem() {
    this.currentIndex =
      (this.currentIndex - 1 + this.items.length) % this.items.length;
    this.showItem(this.currentIndex);
  }
}

customElements.define("brands-descriptions-slider", BrandsDescriptionsSlider);
